import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Editor, EditorModule } from 'primeng/editor';
import Quill from 'quill';
import { Mention, MentionBlot } from 'quill-mention';
Quill.register({ 'blots/mention': MentionBlot, 'modules/mention': Mention });

@Component({
  selector: 'app-editor',
  standalone: true,
  imports: [EditorModule, FormsModule],
  templateUrl: './editor.component.html',
  styleUrl: './editor.component.scss',
})
export class EditorComponent {
  @Input() body: string = '';
  @Input() users: MentionUser[] = [];
  @ViewChild('editor', { static: true }) editor!: Editor;
  @Output() bodyChange = new EventEmitter<EditorOutput>();

  constructor(
    private message : MessageService
  ) {}

  modules: any = {
    mention: {
      mentionDenotationChars: ['@'],
      allowInlineMentionChar: false,
      source: async (searchTerm: any, renderList: any) => {
        const matchedPeople = await this.suggestPeople(searchTerm);
        renderList(matchedPeople);
      },
      onSelect(item: any, insertItem: any) {
        insertItem(item);
      },
    },
    toolbar: [
      // [{ header: '1' }, { header: '2' }, { font: [] }],
      // [{ size: [] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [
        { list: 'ordered' },
        { list: 'bullet' },
        // { indent: '-1' },
        // { indent: '+1' },
      ],
      ['link', 'image', 'video'],
      ['clean'],
    ],
  };
  suggestPeople(searchTerm: any) {
    return searchTerm.length > 0
      ? this.users
          .reduce((acc: MentionUser[], user: MentionUser) => {
            const regex = new RegExp(searchTerm, 'i');
            if (regex.test(user.id) || regex.test(user.value)) {
              acc.push(user);
            }
            return acc;
          }, [])
          .slice(0, 6)
      : this.users.slice(0, 6);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.editor.quill.on(
        'text-change',
        (delta: any, oldContents: any, source: any) => {
          this.mentionedUsers = this.editor.quill
            .getContents()
            .ops.reduce((acc: any, op: any) => {
              if (op.insert && op.insert.mention) {
                acc.push(op.insert.mention.id);
              }
              return acc;
            }, []);
            let size = 0;
          const imageList = this.editor.quill
            .getContents()
            .ops.reduce((acc: any, op: any) => {
              if (op.insert && op.insert.image) {
                acc.push(op.insert.image);
                size = size + op.insert.image.length;
              }
              return acc;
            }, []);

            if(size > 307200){
              this.message.add({severity :'warn', summary: 'Total Image size is too large', detail: 'Please upload images of total size less than 300kb', key: 'tr'})
              this.editor.quill.deleteText(
                this.editor.quill.getLength() - 2,
                this.editor.quill.getLength()
              );
            }
        }
      );
    }, 1000);
  }
  mentionedUsers: string[] = [];

  sentToParent = () => {
    this.bodyChange.emit({
      body: this.body,
      mentionedUsers: this.mentionedUsers,
    });
  };
}

export interface MentionUser {
  id: string;
  value: string;
}
export interface EditorOutput {
  body: string;
  mentionedUsers: string[];
}
